import React from 'react';
import { FilterButton } from '../FilterButton';
import { typeFilters, types, DEFAULT_ORIENTATION } from '../../constants';
import './styles.scss';
import { FilterSelect } from '../FilterSelect';

export const Filters = ({
  currentType,
  onChangeType,
  currentAmenitiesFilters,
  currentTrafficFilters,
  onChangeAmenitiesFilters,
  onChangeTrafficFilters,
  onShowAll,
  hasInteractedWithFilters,
  onShowFeaturedHotspots,
  isShowAllMode,
  allFilterIds,
  onToggleFilter,
  handleShowAllWithFocus,
}) => {
  const filterItems = typeFilters[currentType] || [];

  const currentFilters =
    currentType === 'nganh-nghe'
      ? currentAmenitiesFilters
      : currentTrafficFilters;

  const isDesktop = window.innerWidth > 1024;
  const isMobile = window.innerWidth <= 450;

  // Button text changes based on show all mode
  const btnText = isShowAllMode ? 'Bỏ chọn tất cả' : 'Hiện tất cả tiện ích';

  // Check if a filter should be shown as active
  const isFilterActive = (filterId) => {
    // If in "show all" mode, all filters are active
    if (isShowAllMode) {
      return true;
    }
    return currentFilters.includes(filterId);
  };

  const callFocusTo = (orientation) => {
    if (orientation && typeof window !== 'undefined' && typeof window.focusTo === 'function') {
      try {
        const parsedOrientation = typeof orientation === 'string' ? JSON.parse(orientation) : orientation;
        window.isFocusToCall = true;
        window.focusTo(...parsedOrientation);
      } catch (err) {
        console.error('Failed to parse orientation:', err);
      }
    }
  };

  const handleChangeFilters = (e) => {
    const { id } = e.currentTarget.dataset;
    const orientation = e.currentTarget.dataset.orientation;

    // If id is undefined, null, or empty string, treat as "show all"
    if (!id) {
      callFocusTo(DEFAULT_ORIENTATION);
      onShowAll();
      return;
    }

    // Call window.focusTo with orientation if available
    callFocusTo(orientation);

    // Toggle the individual filter
    onToggleFilter(id);
  };

  if (isDesktop) {
    return (
      <div className="tong-quan-filters desktop">
        <div className="filters-header">
          <div className="tong-quan-switch">
            {types.map((type) => (
              <button
                key={type.id}
                className={`switch-button ${currentType === type.id ? 'active' : ''}`}
                onClick={() => onChangeType(type.id)}
              >
                {type.labelShort}
              </button>
            ))}
          </div>
          <div className="filter-buttons-wrapper">
            <div className="filter-buttons">
              {filterItems.map((filter) => {
                const Icon = filter.icon;
                const isActive = isFilterActive(filter.id);
                return (
                  <FilterButton
                    id={filter.id}
                    key={filter.id}
                    label={filter.label}
                    icon={<Icon color={isActive ? '#5db6b9' : '#5F5552'} />}
                    onChangeFilter={handleChangeFilters}
                    isActive={isActive}
                    showCheckbox={true}
                    defaultOrientation={filter.defaultOrientation}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <div className="filters-container">
          <button
            className="show-all-button"
            onClick={handleShowAllWithFocus}
          >
            {btnText}
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* <div className="tong-quan-switch mobile">
        {types.map((type) => (
          <button
            key={type.id}
            className={`switch-button ${
              currentType === type.id ? 'active' : ''
            }`}
            onClick={() => onChangeType(type.id)}
          >
            {type.label}
          </button>
        ))}
      </div> */}
      <div className="tong-quan-filters mobile">
        <div className="filters-container">
          {isMobile ? (
            <FilterSelect
              filterItems={filterItems}
              currentFilters={currentFilters}
              onChangeFilter={handleChangeFilters}
              onToggleFilter={onToggleFilter}
              isShowAllMode={isShowAllMode}
            />
          ) : (
            <div className="filter-buttons">
              {filterItems.map((filter) => {
                const Icon = filter.icon;
                const isActive = isFilterActive(filter.id);
                return (
                  <FilterButton
                    id={filter.id}
                    key={filter.id}
                    label={filter.label}
                    icon={<Icon color={isActive ? '#5db6b9' : '#5F5552'} />}
                    onChangeFilter={handleChangeFilters}
                    isActive={isActive}
                    showCheckbox={true}
                    defaultOrientation={filter.defaultOrientation}
                  />
                );
              })}
            </div>
          )}
          <button
            className="show-all-button"
            onClick={handleShowAllWithFocus}
          >
            {btnText}
          </button>
        </div>
      </div>
    </>
  );
};
